<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title="Senarai Kutipan : PTJ">

            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                    Penyengelaraan
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">
                        <template ></template>
                        <w-flex justify-space-between class="mb4">
                            <z-input label="Nama"  name="nama" v-model="form.kod" :validators="[validators.required]"/>
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">{{form.saveButton}}</w-button>
                </template>
            </w-dialog>

            <z-table ref="tbluser" title="Kaunter" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="newrecord()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                            <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                             &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                    </w-flex>
                </template>
                <template #item-cell.action_buka="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                            <template v-if="item.ind_buka == 1">
                              <w-button class="ml1 " @click="send(1, item)">
                                   Buka
                                </w-button>
                            </template>
                            <template v-else>
                              <template v-if="item.user_id == $page.props.auth.user.id">
                              <w-button class="ml1 " @click="send(2, item)">
                                   Tutup
                                </w-button>
                              </template>
                            </template>
                    </w-flex>
                </template>
                
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan+'penyengelaraan',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'PTJ ', route: '/kutipan/ptj' }
          ],
          }
  },
  methods: {

    send(status, item){
      this.form.lkp_kaunter_status_id = status
      this.form.id = item.id
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    
                      this.$inertia.visit(this.$route('kutipan.penyengelaraan.kaunter.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    }

  },
  watch: {

  },
  mounted() {
    // override default setting
    // this.getData();
    this.dialog.width = 900

  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
